import type { Dict } from '@aviata/platform-types';

import { extractMismatchData, resolveMismatchedCityNames } from '.';
import type { MismatchedCity, MismatchedCityNames } from '../types';

export const getMismatchedCityNames = (
  dict: Dict.Entity | null,
  cityMismatches: MismatchedCity[] | null,
  flightIdx: number,
): MismatchedCityNames | null => {
  if (!dict) {
    return null;
  }

  const mismatch = extractMismatchData(dict, cityMismatches, flightIdx);

  return mismatch ? resolveMismatchedCityNames(dict, mismatch) : null;
};
